import { render, staticRenderFns } from "./selecttable.vue?vue&type=template&id=5b48f60f&scoped=true&"
import script from "./selecttable.vue?vue&type=script&lang=js&"
export * from "./selecttable.vue?vue&type=script&lang=js&"
import style0 from "./selecttable.vue?vue&type=style&index=0&id=5b48f60f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b48f60f",
  null
  
)

export default component.exports